import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export type OrderDeliveredBadgeType = "delivered" | "collected";

export const OrderDeliveredBadge = (
  props: BadgeProps & {
    type: OrderDeliveredBadgeType;
  },
): React.ReactElement => (
  <Badge
    {...props}
    icon={"CHECK_ALL"}
    className={twMerge("bg-blue-100 text-blue-700", props.className)}
  >
    Order {props.type}
  </Badge>
);
